import React, { useState } from 'react';
import { Table, Form, Pagination, Badge } from 'react-bootstrap';

const UserList = ({
  users,
  onEditUser,
  onDeleteUser,
  onSearch,
  onSort,
  sortConfig,
  currentPage,
  usersPerPage,
  totalUsers,
  paginate,
  isAdmin
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    onSearch(e.target.value);
  };

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalUsers / usersPerPage); i++) {
    pageNumbers.push(i);
  }

  const getSortDirection = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? '↑' : '↓';
    }
    return '';
  };

  const renderStatus = (user) => {
    if ('is_active' in user) {
      return user.is_active ?
        <Badge bg="success">Active</Badge> :
        <Badge bg="warning">Inactive</Badge>;
    }
    return <Badge bg="secondary">Unknown</Badge>;
  };

  // Add this function to format numbers with commas
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const isActionDisabled = (targetUser) => {
    // Handle both old format (role) and new format (roles)
    const targetUserRoles = targetUser.roles || [targetUser.role];

    return targetUserRoles.includes('admin') && !isAdmin;
  };

  return (
    <>
      <div className="card-header d-flex justify-content-between align-items-center">
        <div></div>
        <div>
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>

      </div>

      <div className="mb-2">
        (To Sort by the Information Column, Please Click on the Column Header)
      </div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th onClick={() => onSort('lastname')}>
              Name of User {getSortDirection('lastname')}
            </th>
            <th onClick={() => onSort('username')}>
              Username {getSortDirection('username')}
            </th>
            <th onClick={() => onSort('email')}>
              Email {getSortDirection('email')}
            </th>

            <th onClick={() => onSort('created_at')}>
              Created
              {getSortDirection('created_at')}
            </th>
            <th onClick={() => onSort('last_login_at')}>
              Last Login
              {getSortDirection('last_login_at')}
            </th>

            {/* <th onClick={() => onSort('role')}>
              Role {getSortDirection('role')}
            </th>
            <th onClick={() => onSort('is_active')}>
              Status {getSortDirection('is_active')}
            </th> */}
            <th onClick={() => onSort('projects')}>
              Projects {getSortDirection('projects')}
            </th>
            <th onClick={() => onSort('files')}>
              Files {getSortDirection('files')}
            </th>
            <th onClick={() => onSort('disk_space')}>
              Files Size {getSortDirection('disk_space')}
            </th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.lastname}, {user.firstname}</td>
              <td>{user.username}</td>
              <td>{user.email}</td>
              <td>{new Date(user.created_at).toLocaleDateString()}</td>
              <td>{user.last_login_at ? new Date(user.last_login_at).toLocaleDateString() : ''}</td>
              {/* <td>{user.role}</td>
              <td>{renderStatus(user)}</td> */}
              <td>{formatNumber(user.projects)}</td>
              <td>{formatNumber(user.files)}</td>
              <td>{user.disk_space}</td>

              <td>

                <div className="d-flex gap-2">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onEditUser(user)}
                    disabled={isActionDisabled(user)}
                  >
                    <i className="bi bi-pencil"></i>
                  </button>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => onDeleteUser(user)}
                    disabled={isActionDisabled(user)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </td>

            </tr>
          ))}
        </tbody>
      </Table>
      <div className="card-footer d-flex justify-content-between align-items-center bg-white">
        <div>
          <Pagination>
            {pageNumbers.map(number => (
              <Pagination.Item key={number} active={number === currentPage} onClick={() => paginate(number)}>
                {number}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </div>
    </>
  );
};

export default UserList;